export default __webpack_public_path__ + "static/media/epitech_thumbnail.1e8451ab.png";